var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('TableApp', {
    ref: "pessoa",
    attrs: {
      "titulo": "Contador",
      "subTitulo": "Defina seu contador para gerar Sped",
      "acaoBtn": "/#/contador/novo",
      "textoBtn": "Novo",
      "api-url": "pessoa/contador",
      "fields": _vm.fields,
      "classFilterColumn": "pessoa",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'nome' ? _c('span', {
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('span', {
          staticClass: "pl-0 pt-8"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "symbol symbol-40 symbol-light-primary flex-shrink-0",
          staticStyle: {
            "margin-right": "10px"
          }
        }), _c('div', [_c('a', {
          staticClass: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg",
          attrs: {
            "href": "#"
          }
        }, [_vm._v(_vm._s(props.rowData.nome))])])])])]) : _vm._e(), props.field == 'cnpj_cpf' ? _c('span', {
          attrs: {
            "slot": "cnpj_cpf"
          },
          slot: "cnpj_cpf"
        }, [_c('span', {
          staticStyle: {
            "width": "110px"
          }
        }, [_c('div', {
          staticClass: "font-weight-bolder font-size-lg mb-0"
        }, [_vm._v(" " + _vm._s(_vm.formatarCampo(props.rowData.cnpj_cpf)) + " ")]), _c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" CRC: " + _vm._s(props.rowData.crc) + " ")])])]) : _vm._e(), props.field == 'status' ? _c('span', {
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [props.rowData.status == 'A' ? _c('span', {
          staticClass: "label label-lg label-inline label-light-success"
        }, [_vm._v("Ativo")]) : _c('span', {
          staticClass: "label label-lg label-inline label-light-danger"
        }, [_vm._v("Inativo")])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'contadorEditar',
              params: {
                id_pessoa: props.rowData.id_pessoa
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)])])]) : _vm._e()];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };